import '@babel/polyfill';
import React, {Fragment, lazy, Suspense} from 'react'
import PropTypes from 'prop-types'
import Router from 'next/router';
import Block from '../adapters/helpers/Block';
import { addBVScript } from '../adapters/helpers/Utils';
import { addBVCollectionPageCallback } from '../adapters/helpers/Utils';
import contentfulClient from '../adapters/model/ContentfulClient';
const Meta = lazy(() => import('../components/Meta/Meta'));
const GTMScriptFunction = lazy(() => import('../components/GTMScriptFunction'));
const Loader = lazy(() => import('../adapters/helpers/Loader'));

class Collection extends React.Component {

    componentDidMount() {
        Router.beforePopState(({as}) => {
            location.href = as;
        });

        addBVScript();
        addBVCollectionPageCallback();
    }

    static async getInitialProps({ asPath, query }) {
        const siteLocale = process.env.SITE_LOCALE;
        let languageCode, countryCode;
        if (siteLocale) {
            languageCode = siteLocale.substring(0, 2);
            countryCode = siteLocale.slice(-2);
        } else {
            const client = await contentfulClient.getClient();
            const locales = await client.getLocales();
            const defaultLocale = locales.items.find(locale => locale.default);
            countryCode = defaultLocale.code.slice(-2);
            languageCode = defaultLocale.code.substring(0, 2);
        }

        const path = query.slug || asPath;
        const baseProps = await this.initPage(path, query);
        baseProps.countryCode = countryCode;
        baseProps.languageCode = languageCode;

        return {
            ...baseProps
        }
    }

    static async initPage(slug, query) {
        let collection = undefined;

        if (slug) {
            const { default: collectionDao } = await import('Model/dao/CollectionDao');
            collection = await collectionDao.getActiveCollectionBySlug(slug);
        }

       if(collection?.fields?.series){
            collection?.fields?.series?.map((allSeries)=>{
                if(allSeries?.fields?.backgroundAsset?.fields){
                    allSeries.fields.backgroundAsset.fields.isBannerImage = true;
                }
                if(allSeries?.fields?.mobileBackgroundAsset?.fields){
                    allSeries.fields.mobileBackgroundAsset.fields.isBannerImage = true;
                }
            })
        }
        else{
            collection?.fields?.blocks[0]?.fields?.blocks[1]?.fields?.blocks.map((blocksArr)=>{
                if(blocksArr?.fields?.devicesConfigurations){
                    blocksArr?.fields?.devicesConfigurations.map((devices)=>{
                        if(devices.fields.backgroundAsset){
                            devices.fields.backgroundAsset.isBannerImage = true;
                            if(devices.fields.backgroundAsset.fields){
                                devices.fields.backgroundAsset.fields.isBannerImage = true;
                            }
                        }
                    })
                }
            })
        }

        return {'collection' : collection, 'slug' : slug, 'query' : query};
    }

    constructor(props) {
        super(props);
    }

    /**
     * Rendering of the page. This always render the page using a common layout.
     *
     * Override the render method to do otherwise.
     *
     * @returns {*}
     */
    render() {
        let collection = this.getCollection();
        let pagePath = collection.slug.fields.slug;
        const query = this.props.query;
        const selectedSeriesId = query?.series;

        let metaData = this.getMetadata()
        if(metaData){
            metaData.pageType = 'collection'
        }
        return (
            <Suspense fallback={<Loader />}>
                <Fragment>
                    {!selectedSeriesId ? <Suspense fallback={<Loader />}>
                                            <Meta metadata={metaData} pagePath={pagePath} /> 
                                          </Suspense>: null}
                    <div className="ob-wrapper">
                        <Suspense fallback={<Loader />}>
                            {this.renderBody()}
                        </Suspense>
                    </div>
                    <Suspense fallback={<Loader />}><GTMScriptFunction languageCode={this.props.languageCode} countryCode={this.props.countryCode} /></Suspense>
                </Fragment>
            </Suspense>
        )
    }

    getCollection() {
        return this.props.collection.fields;
    }

    getMetadata() {
        return this.props.collection.fields.metadata.fields
    }

    /**
     * By default, the page will render the modules of the Product.
     * Can be overridden on the child class to do specific rendering.
     * @returns {*|void}
     */
    renderBody() {
        return new Block(this.props.collection).renderChildBlocks({ extraAttributes : {entity: this.getCollection(), slug: this.props.slug, query: this.props.query} });
    }

}

Collection.propTypes = {
    collection: PropTypes.object,
    slug: PropTypes.any,
    query: PropTypes.object,
    languageCode: PropTypes.string,
    countryCode: PropTypes.string
}

export default Collection
